<template>
  <transition name="fade-transverse" mode="out-in">
    <div class="c-setting-personal-component" :style="{'z-index': zIndex + 3}">
      <el-popover
          v-model="show"
          placement="bottom"
          popper-class="personal-popover"
          @hide="hide"
          trigger="click">
        <img :src="$store.state.user.userInfo.headImg" alt="">
        <div class="personal-con">
          <p class="name">{{ $store.state.user.userInfo.nickName }}</p>
          <p class="register-account">注册账号：{{ $store.state.user.userInfo.phone }}</p>
          <p class="register-time" v-if="currentUserInfo.createAt">注册时间：{{ currentUserInfo.createAt | time('yyyy-MM-dd HH:mm:ss') }}</p>
          <p class="pre-login-time" v-if="currentUserInfo.lastLoginAt">上次登录时间：{{ currentUserInfo.lastLoginAt | time('yyyy-MM-dd HH:mm:ss') }}</p>
        </div>
        <i class="iconfont" slot="reference"></i>
      </el-popover>
    </div>
  </transition>
</template>
<script>
  import mask from '@/mixins/mask'
  export default {
    mixins: [mask],
    data(){
      return {
        show: false,
        currentUserInfo: {}
      }
    },
    methods: {
      curUser(){
        this.$http('userCurUser').then( res => {
          if(!res.errorCode) {
            this.currentUserInfo = res.data;
          }
        })
      },
      hide(){
        this.$emit('hide')
      }
    },
    mounted(){
      this.$on('show', () => {
        this.show = true;
        this.curUser()
      })
    }
  }
</script>
<style lang="scss" scoped>
  .c-setting-personal-component {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 20px;

  }
</style>
<style lang="scss">
  .personal-popover.el-popper {
    width: 395px;
    background-color: #090E38;
    border-color: #090E38;
    color: #FFFFFF;
    padding: 24px;
    display: flex;
    img {
      width: 42px;
      height: 42px;
      margin-right: 12px;
      border-radius: 50%;
      background-color: #eee;
    }
    .personal-con {
      font-size: 13px;
      line-height: 34px;
      .name {
        font-size: 16px;
      }
    }
    .popper__arrow {
      border-bottom-color: #090E38;
    }
    .popper__arrow::after {
      border-bottom-color: #090E38;
    }
  }
</style>